// extracted by mini-css-extract-plugin
export default {"caption":"LongCaption_caption__+DLXs","marginSmall":"LongCaption_marginSmall__wqn6O"};